import './bootstrap';
import '../css/apptheme.css';
import '../css/app.css';
import '../css/style.css';
import { createApp, h } from 'vue';
import { Inertia } from '@inertiajs/inertia'; // Import Inertia directly

import { createInertiaApp,Head, Link,useForm,router } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueNumberFormat from 'vue-number-format'
import { isLoading } from '@/loadingState';
import JQuery from 'jquery';
window.$ = JQuery;
 
const appName = import.meta.env.VITE_APP_NAME || 'Larval';
 
// ... rest of your existing code ...
createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use('swal',Swal)
            .use(VueNumberFormat, { prefix: 'R$ ', decimal: ',', thousand: '.'})
            .component('Link', Link)
            .component('Head', Head)
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});

Inertia.on('finish', (event) => {
    if (event.detail.visit.completed || event.detail.visit.interrupted) {
        isLoading.value = false;
    }
});
 

window.confirm = (url) => {

    const form = useForm({});

    Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        backdrop:true,
        allowOutsideClick: false,
        allowEscapeKey: false,
    }).then((result) => {
        if (result.isConfirmed) {
            form.delete(url);
        }
    });
},

window.alert = (message, icon, time, position,showConfirmButton) => {
    Swal.fire({
        icon: icon,
        position:position??'center',
        text: message,
        timerProgressBar: true,
        showConfirmButton: showConfirmButton??true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        backdrop:true,
        confirmButtonColor: '#a5dc86',
    });
};
window.custom = (message) => {
    Swal.fire({
        icon:'success',
        position:'center',
        text: message,
        timerProgressBar: true,
        showConfirmButton:true,
        showCancelButton:false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        backdrop: true,
        confirmButtonColor: '#283480',
        cancelButtonColor: '#6B7280',
        confirmButtonText: 'Go to Login',
        cancelButtonText: 'Cancel'
    }).then((result) => {
        if (result.isConfirmed) {
            window.location.href = '/login';
        }
    });
};

 
window.visitUrl = (url) => {
    Swal.fire({
        title: 'Are you sure?',
        text: "",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        backdrop:true,
        allowOutsideClick: false,
        allowEscapeKey: false,
    }).then((result) => {
        if (result.isConfirmed) {
            router.visit(url);
        }
    });
}
 